import { FilterItemType, type FilterItem } from '../../types';
import { FilterCheckboxField } from '../FilterCheckboxField';
import { FilterRadioField } from '../FilterRadioField';

type FilterGropItemProps = {
  filterItem: FilterItem;
};

export const FilterGropItem = ({ filterItem }: FilterGropItemProps) => {
  switch (filterItem.type) {
    case FilterItemType.checkbox:
      return <FilterCheckboxField key={filterItem.name} item={filterItem} />;
    case FilterItemType.radio:
      return <FilterRadioField item={filterItem} />;
    default:
      return <></>;
  }
};
